import { gql } from "@apollo/client";
import { PageDataFragment } from "../PageData";
import { EventFragment } from "../Event";
import { ExhibitTypeFragment } from "../Exhibit";

export const SonicConnectionsFragment = gql`
  ${PageDataFragment}
  ${EventFragment}
  ${ExhibitTypeFragment}
  fragment SonicConnections on FeatureDataSonicConnections {
    headline
    subhead
    tracks {
      heroImage {
        ...ACFMedia
      }
      trackName
      artistName
      releaseYear
      audio
      flipContentOrder
      images {
        image {
          ...ACFMedia
        }
      }
      blurbs {
        eyebrow
        copy
      }
    }
    includeFeature
    feature {
      headline
      items {
        body
        ctaLabel
        headline
        sectionId
        linkType
        pillLabel
        image {
          ...ACFMedia
        }
        externalLink
        page {
          node {
            __typename
            uri
            ... on Exhibit {
              ...ExhibitType
            }
            ... on Event {
              ...EventFragment
            }
          }
        }
      }
    }
    gridInductees {
      headline
      featuredInductees(first: 40) {
        nodes {
          ... on Inductee {
            title
            uri
            ...PageData
            inducteeData {
              inducteeClass {
                slug
              }
            }
          }
        }
      }
      cta {
        linkType
        label
        externalLink
        page {
          node {
            uri
          }
        }
      }
    }
  }
`;